import React from 'react'

function TableIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="140"
      height="62"
      viewBox="0 0 140 62"
      fill="none"
    >
      <rect x="5" y="6" width="130" height="56" fill="white" />
      <rect width="140" height="6" fill="#EBEBEB" />
    </svg>
  )
}

export default TableIcon
